<template>
  <div class="wrapper">
    <div class="main visual-2 enter-phone appointment-id">
      <Header backRoute="/verify-appointment" />

      <div class="vis4-inr1">
        <h1 v-if="!appointment?.id">Enter Your Appointment ID</h1>

        <!-- Input form -->
        <form
          v-if="!appointment?.id"
          @submit.prevent="handleSubmit"
          class="namesearch"
        >
          <label for="appointmentID">Appointment ID</label>
          <input
            type="number"
            id="appointmentID"
            name="appointmentID"
            placeholder="Appointment ID"
            v-model="appointmentID"
            required
          />
          <div class="sbmt">
            <button type="submit" :disabled="isLoading">
              Next
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </form>

        <!-- Appointment Details -->
        <div v-else class="appointment-status">
          <h2 class="appointment-header">Appointment Status</h2>

          <table class="appointment-table">
            <tbody>
              <tr>
                <td><strong>Doctor Name:</strong></td>
                <td>
                  {{ appointment?.doctor?.firstname }}
                  {{ appointment?.doctor?.lastname }}
                </td>
              </tr>
              <tr>
                <td><strong>Patient Name:</strong></td>
                <td>
                  {{ appointment?.patient?.firstname }}
                  {{ appointment?.patient?.lastname }}
                </td>
              </tr>
              <tr>
                <td><strong>Date:</strong></td>
                <td>
                  {{
                    new Date(appointment?.assignedStartTime).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      }
                    )
                  }}
                </td>
              </tr>
              <!-- <tr v-else>
                <td><strong>Preferred Dates:</strong></td>
                <td>
                  <span v-for="(date, index) in appointment.preferredDates" :key="index">
                    {{ convertToLocal(date)
                    }}<span v-if="index < appointment.preferredDates.length - 1">, </span>
                  </span>
                </td>
              </tr> -->
              <tr>
                <td><strong>Time:</strong></td>
                <td>
                  {{
                    new Date(appointment?.assignedStartTime).toLocaleTimeString(
                      [],
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Status message outside table -->
          <p v-if="message" class="text-danger status-message">{{ message }}</p>

          <!-- Check-In Button -->
          <div class="chkin">
            <button
              v-if="checkInButton"
              class="btn btn-primary"
              @click="
                $router.push({
                  path: '/chose-option',
                  query: { code: appointmentID },
                })
              "
            >
              Check In
            </button>
          </div>
        </div>
      </div>

      <FooterView :showButtons="true" />
    </div>
  </div>
</template>

<script>
import { AppointmentService } from "@/services/appointments.service";
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "EnterAppointmentID",
  data() {
    return {
      appointmentID: "", // Stores entered Appointment ID
      isLoading: false, // Loading state
      appointment: {}, // Stores appointment details
      message: "", // Error/Info messages
      checkInButton: false, // Controls check-in button visibility
    };
  },
  methods: {
    convertToLocal(utcDate) {
      if (!utcDate) return "";

      const localDate = new Date(utcDate);
      const day = String(localDate.getDate()).padStart(2, "0");
      const month = localDate.toLocaleString("en-US", { month: "short" }); // Get short month name (e.g., Feb)
      const year = localDate.getFullYear();

      return `${day} ${month} ${year}`;
    },
    async handleSubmit() {
      this.message = "";
      if (!this.appointmentID) {
        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Appointment ID is required!",
        });
        return;
      }

      this.isLoading = true;

      try {
        // Fetch appointment details
        const response = await AppointmentService.getByCode(this.appointmentID);

        if (!response.success) {
          this.$store.commit("toast/NEW", {
            type: "error",
            message: response.message || "Invalid Appointment ID!",
          });
          return;
        }

        this.appointment = response.data?.appointment;

        // If appointment is not approved yet
        if (this.appointment.status === "open") {
          this.message = "Note: Your Appointment is not Approved Yet!";
          return;
        }

        // Set check-in button availability from API
        this.checkInButton = response.data?.doctorSlotAvailable;

        // Compare appointment date with today's date
        const appointmentDate = new Date(this.appointment.assignedStartTime);
        const today = new Date();

        if (
          appointmentDate.toLocaleDateString() === today.toLocaleDateString()
        ) {
          // ✅ Appointment is today
          this.message = "Your appointment is today. You can check in now!";
          this.checkInButton = true;
        } else {
          // 🕓 Appointment is for another day
          this.message = "Note: Your appointment isn’t today!";
          if (this.checkInButton) {
            this.message =
              "Note: Your appointment isn’t today, but no worries—we can still check you in. Let’s get started!";
          }
        }
      } catch (error) {
        this.$store.commit("toast/NEW", {
          type: "error",
          message: error?.response?.data?.message || "Invalid Appointment ID!",
        });
      } finally {
        this.isLoading = false;
      }
    },
    // async handleSubmit() {
    //   this.message = "";
    //   if (!this.appointmentID) {
    //     this.$store.commit("toast/NEW", {
    //       type: "error",
    //       message: "Appointment ID is required!",
    //     });
    //     return;
    //   }

    //   this.isLoading = true;

    //   try {
    //     // Fetch appointment details
    //     const response = await AppointmentService.getByCode(this.appointmentID);
    //     if (!response.success) {
    //       this.$store.commit("toast/NEW", {
    //         type: "error",
    //         message: response.message || "Invalid Appointment ID!",
    //       });
    //       return;
    //     }

    //     this.appointment = response.data?.appointment;

    //     if (this.appointment.status === "open") {
    //       this.message = "Note: Your Appointment is not Approved Yet!";
    //       return;
    //     }

    //     this.checkInButton = response.data?.doctorSlotAvailable;

    //     // Compare appointment date with today
    //     const appointmentDate = new Date(this.appointment.assignedStartTime);
    //     const today = new Date();

    //     if (
    //       appointmentDate.toLocaleDateString() === today.toLocaleDateString()
    //     ) {
    //       this.$router.push({
    //         path: "/chose-option",
    //         query: { code: this.appointmentID },
    //       });
    //     } else {
    //       this.message = "Note: Your appointment isn’t today!";
    //       if (this.checkInButton) {
    //         this.message =
    //           "Note: Your appointment isn’t today, but no worries—we can still check you in. Let’s get started!";
    //       }
    //     }
    //   } catch (error) {
    //     this.$store.commit("toast/NEW", {
    //       type: "error",
    //       message: error?.response?.data?.message || "Invalid Appointment ID!",
    //     });
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
  },
};
</script>

<style scoped>
.appointment-status {
  max-width: 722px;
  margin: 20px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
}

.appointment-header {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}

.appointment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}

.appointment-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.appointment-table td {
  padding: 10px 15px;
  border: 1px solid #ddd;
}

.appointment-table td:first-child {
  font-weight: bold;
  color: #34495e;
  text-align: left;
}

.appointment-table td:last-child {
  text-align: right;
  color: #2c3e50;
}

.status-message {
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
/* Hide arrows in Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide arrows in Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.chkin {
  text-align: center;
}
.chkin button {
  font-size: 18px;
  padding: 18px 50px;
}
</style>
